import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash'; // eslint-disable-line

// Local Components
import { ReservationContext } from '../../context/reservation-context';
import { ReservationLookupApiContext } from '../../context/ReservationLookupApiContext';
import { Landing } from './landing/landing';
import { Flow } from './flow/flow';
import { Summary } from './summary/summary';
import { CancelModal } from '../../components/cancel-modal/cancel-modal';

// CSS
import './reservation-modify-form.scss';

export const ReservationModifyForm = () => {
  const [showCancel, setShowCancel] = useState(false);
  const [showModifyFlow, setShowModifyFlow] = useState(false);
  const [showModifySummary, setShowModifySummary] = useState(false);

  const [reservationState, dispatch] = useContext(ReservationContext);
  const { executeRequest } = useContext(ReservationLookupApiContext);

  const { uuid, reservationId } = reservationState;

  useEffect(() => {
    executeRequest();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(reservationState?.selectedStore)) {
      setShowModifySummary(true);
    } else {
      setShowModifySummary(false);
    }
  }, [reservationState?.selectedStore]);

  return (
    <div className="parent-container" data-component="ReservationModifyForm">
      <div className="reservation-modify-form">
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        {
          !showModifySummary && !showModifyFlow && (
            <Landing
              showCancel={() => setShowCancel(true)}
              showModifyFlow={() => setShowModifyFlow(true)}
            />
          )
        }
        {
          showModifyFlow && !showModifySummary && (
            <Flow />
          )
        }
        {
          showModifySummary && (
            <Summary />
          )
        }
        <CancelModal
          opened={showCancel}
          reservationId={reservationId}
          toggleOpened={() => setShowCancel(!showCancel)}
          uuid={uuid}
        />
      </div>
    </div>
  );
};

ReservationModifyForm.propTypes = {};
